import attack from "../../request/request";
import {UCENTER} from "../requers_variable";

export default {
    /**
     * 获取用户的微信信息
     *
     * @returns
     */
    qrCodeUrl(params) {
        return new Promise(function(resolve, reject) {
            attack({
                type: 'get',
                url: `${UCENTER}/wechat/qrcode/url`,
                data: params,
                success(rep) {
                    resolve(rep.data)
                },
                error(rep) {
                    resolve(false)
                }
            })
        })
    },
    /**
     * 生成登录微信
     *
     * @returns
     */
     generateCode(params) {
        return new Promise(function(resolve, reject) {
            attack({
                type: 'get',
                url: `${UCENTER}/wechat/scan/generateCode`,
                data: params,
                success(rep) {
                    resolve(rep)
                },
                error(rep) {
                    resolve({
                        status: false,
                        code: '',
                        msg: rep.message
                    })
                }
            })
        })
    }
}


// WEBPACK FOOTER //
// ./src/data/ucenter/wechat.js